import { apiInstance } from '../../api';
import {getRefreshToken} from "../../../lib/session";

export const refreshTokenRoute = 'auth/refreshToken';

export class RefreshTokenService {
  static refreshAccessToken() {
    return apiInstance.post(refreshTokenRoute, {
      refreshToken: getRefreshToken(),
    });
  }
}
